import React, { Fragment } from 'react';
import _isArray from 'lodash/isArray';
import FeatureListItem from '../Features/FeatureListItem';

const FlowABTestFeature = ({ selected }) => (
  <FeatureListItem
    id={2}
    label='flow.features.ab-test.label'
    defaultLabel='A/B Test'
    selected={selected}
    type='checkbox'
    paramName='ab_test'
    title='flow.features.ab-test.label'
    defaultTitle='A/B Test'
    desc='flow.features.ab-test.desc'
    defaultDesc='<p>Do you want to compare the conversion for different variants of landings and transit pages?</p><p>When you select two or more landing pages, the A/B test is activated, after which all traffic will be distributed along the stream to the selected landing pages.</p><p>Test results will be available on the setup page of this flow.</p>'
    onChange={() => false}
    tag={Fragment}
    value={1}
    disabled
  />
);

export default FlowABTestFeature;
